import React from 'react'

const withContainer = Component => () => {
  return <Component />
}

export default withContainer
